import _defineProperty from "/tmp/build_4c901a35/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/tmp/build_4c901a35/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import { SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME, SEMANTIC_ATTRIBUTE_PROFILE_ID } from '../semanticAttributes.js';
/**
 * Converts a transaction event to a span JSON object.
 */

function convertTransactionEventToSpanJson(event) {
  var _event$contexts$trace, _event$contexts, _event$start_timestam;

  var _ref = (_event$contexts$trace = (_event$contexts = event.contexts) === null || _event$contexts === void 0 ? void 0 : _event$contexts.trace) !== null && _event$contexts$trace !== void 0 ? _event$contexts$trace : {},
      trace_id = _ref.trace_id,
      parent_span_id = _ref.parent_span_id,
      span_id = _ref.span_id,
      status = _ref.status,
      origin = _ref.origin,
      data = _ref.data,
      op = _ref.op;

  return {
    data: data !== null && data !== void 0 ? data : {},
    description: event.transaction,
    op: op,
    parent_span_id: parent_span_id,
    span_id: span_id !== null && span_id !== void 0 ? span_id : '',
    start_timestamp: (_event$start_timestam = event.start_timestamp) !== null && _event$start_timestam !== void 0 ? _event$start_timestam : 0,
    status: status,
    timestamp: event.timestamp,
    trace_id: trace_id !== null && trace_id !== void 0 ? trace_id : '',
    origin: origin,
    profile_id: data === null || data === void 0 ? void 0 : data[SEMANTIC_ATTRIBUTE_PROFILE_ID],
    exclusive_time: data === null || data === void 0 ? void 0 : data[SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME],
    measurements: event.measurements,
    is_segment: true
  };
}
/**
 * Converts a span JSON object to a transaction event.
 */


function convertSpanJsonToTransactionEvent(span) {
  return {
    type: 'transaction',
    timestamp: span.timestamp,
    start_timestamp: span.start_timestamp,
    transaction: span.description,
    contexts: {
      trace: {
        trace_id: span.trace_id,
        span_id: span.span_id,
        parent_span_id: span.parent_span_id,
        op: span.op,
        status: span.status,
        origin: span.origin,
        data: _objectSpread(_objectSpread(_objectSpread({}, span.data), span.profile_id && _defineProperty({}, SEMANTIC_ATTRIBUTE_PROFILE_ID, span.profile_id)), span.exclusive_time && _defineProperty({}, SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME, span.exclusive_time))
      }
    },
    measurements: span.measurements
  };
}

export { convertSpanJsonToTransactionEvent, convertTransactionEventToSpanJson };